var React = require('react');

function Advice (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.6071 10.3929H18.4286C19.0202 10.3929 19.5 10.8727 19.5 11.4643V12.5357C19.5 13.1273 19.0202 13.6071 18.4286 13.6071H13.6071V18.4286C13.6071 19.0202 13.1273 19.5 12.5357 19.5H11.4643C10.8727 19.5 10.3929 19.0202 10.3929 18.4286V13.6071H5.57143C4.9798 13.6071 4.5 13.1273 4.5 12.5357V11.4643C4.5 10.8727 4.9798 10.3929 5.57143 10.3929H10.3929V5.57143C10.3929 4.9798 10.8727 4.5 11.4643 4.5H12.5357C13.1273 4.5 13.6071 4.9798 13.6071 5.57143V10.3929Z"}));
}

Advice.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Advice;

Advice.default = Advice;
